import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TUploadState = {
  uploaded: boolean;
  // template.step2[].imageName, step3[].imageNameの更新に使用
  lastUploadedImage: { recordId: string; name: string } | null;
};

const initialState: TUploadState = {
  uploaded: false,
  lastUploadedImage: null,
};

const _module = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    uploaded(state: TUploadState, action: PayloadAction<boolean>) {
      return {
        ...state,
        uploaded: action.payload,
      };
    },
    clearState() {
      return initialState;
    },
    // step2[].imageName, step3[].imageNameの更新に使用
    imageUploadedSuccess(state: TUploadState, action: PayloadAction<{ recordId: string; name: string }>) {
      return { ...state, lastUploadedImage: action.payload };
    },
    clearLastUploadedImage(state: TUploadState) {
      return { ...state, lastUploadedImage: null };
    },
  },
});

export const uploadModule = _module;
